var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{style:(("width: 100%; height: 30px; text-align: center; background-color: " + _vm.value))}):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }